import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, Avatar, Button } from '@material-ui/core';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import decode from 'jwt-decode';

import useStyles from './styles';
import applicationLogo from '../../images/applicationLogo.png';
import applicationText from '../../images/applicationText.png';
import * as actionType from '../../constants/actionTypes';

export const Navbar = () => {
    const classes = useStyles();
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();

    const logout = () => {
        history.push('/auth');
        setUser(null);
        dispatch({ type: actionType.LOGOUT });
    };
    useEffect(() => {
        const token = user?.token;
        if (token) {
          const decodedToken = decode(token);
          if (decodedToken.exp * 1000 < new Date().getTime()) logout();
        }
    
        setUser(JSON.parse(localStorage.getItem('profile')));
      }, [location]);

      const handleClick = () => {
          logout();
          location.reload();
      };
  
    return (
        <AppBar className = { classes.appBar } position = 'static' color = 'inherit'>
            <Link to='/' className= { classes.brandContainer }>
                <img src = {applicationText} alt= 'icon'/>
                <img className = { classes.image } src = { applicationLogo } alt="applicationLogo" height="60px"/>
            </Link>
            <Toolbar className = { classes.toolbar }>
                {user ?(
                    <div className = { classes.profile }>
                        <Avatar className={classes.purple} alt={user?.result.name} src={user?.result.imageUrl}>{user?.result.name.charAt(0)}</Avatar>
                        <Typography className={classes.userName} variant="h6">{user?.result.name}</Typography>
                        <Button variant="contained" className={classes.logout} color="secondary" onClick={handleClick}>Logout</Button>
                    </div>
                ):(
                    <Button component = { Link } to = '/auth' variant = 'contained' color = 'primary'> Sign In </Button>
                )}
            </Toolbar>
        </AppBar>
    );
};

export default Navbar;